<template>
  <div class="christmas-draw">
    <img src="./images/bg.png" alt="" />
    <div class="swiper-content">
      <swiper ref="mySwiper" :options="swiperOption">
        <swiper-slide v-for="(item, index) of list" :key="index">
          <div class="rank-item">
            <div class="avatar-box">
              <img :src="getIcon(index)" alt="" class="icon" />
              <img :src="item.avatarUrl" alt="" class="avatar" />
              <img src="./images/border.png" alt="" class="avatar-border" />
              <button type="button" class="user-name">
                {{ item.userName }}
              </button>
            </div>
          </div>
        </swiper-slide>
      </swiper>
    </div>
  </div>
</template>
<script>
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper';
import top4 from './images/4.png';
import top5 from './images/5.gif';
import top6 from './images/6.png';
import top7 from './images/7.png';
import top8 from './images/8.png';
import top9 from './images/9.png';
import top10 from './images/10.png';
import topIcon4 from './images/i4.png';
import topIcon5 from './images/i5.png';
import topIcon6 from './images/i6.png';
import topIcon7 from './images/i7.png';
import topIcon8 from './images/i8.png';
import topIcon9 from './images/i9.png';
import topIcon10 from './images/i10.png';
import 'swiper/css/swiper.min.css';

export default {
  name: 'NewYear',
  components: {
    Swiper,
    SwiperSlide
  },
  directives: {
    swiper: directive
  },
  data() {
    return {
      swiperOption: {
        loop: true,
        autoplay: {
          delay: 2000,
          disableOnInteraction: true,
        },
        slidesPerView: 'auto',
        slideClass: 'custom-slide-class'
      },
      list: [
        {
          avatarUrl: top4,
          userName: '喵喵🐈'
        },
        {
          avatarUrl: top5,
          userName: '吾橋沒水'
        },
        {
          avatarUrl: top6,
          userName: '糕糕人不在可先預約'
        },
        {
          avatarUrl: top7,
          userName: 'UNA傳說Apex  Raber'
        },
        {
          avatarUrl: top8,
          userName: 'Raber'
        },
        {
          avatarUrl: top9,
          userName: '小瀞'
        },
        {
          avatarUrl: top10,
          userName: 'ACS冠軍隊教練'
        }
      ]
    };
  },
  methods: {
    getIcon(index) {
      let icon = '';
      switch (index) {
        case 0:
          icon = topIcon4;
          break;
        case 1:
          icon = topIcon5;
          break;
        case 2:
          icon = topIcon6;
          break;
        case 3:
          icon = topIcon7;
          break;
        case 4:
          icon = topIcon8;
          break;
        case 5:
          icon = topIcon9;
          break;
        case 6:
          icon = topIcon10;
          break;
      }
      return icon;
    },
    // 初始化根字体大小
    initHtmlFontSize() {
      const html = document.getElementsByTagName('html')[0];
      this.htmlOriginalFontSize = html.style.fontSize;
      html.style.fontSize = '0.625vw'; //设计稿宽1920 根字体12px
    },
    // 重置根字体大小
    resetHtmlFontSize() {
      const html = document.getElementsByTagName('html')[0];
      html.style.fontSize = this.htmlOriginalFontSize;
    }
  },
  created() {
    this.initHtmlFontSize();
  },
  destroyed() {
    this.resetHtmlFontSize();
  }
};
</script>
<style lang="scss" scoped>
.christmas-draw {
  width: 100%;
  height: 100vh;
  overflow: auto;
  position: relative;
  img {
    width: 100%;
    max-width: 100%;
  }
  .swiper-content {
    position: absolute;
    top: 235rem;
    left: 50%;
    width: 87.83rem;
    transform: translateX(-50%);
  }
  /deep/ .custom-slide-class {
    width: 21.75rem !important;
    .rank-item {
      width: 20.33rem;
      margin-left: 1.42rem;
      text-align: center;
      font-size: 2rem;
      .avatar-box {
        height: 29.67rem;
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        align-items: center;
        padding-bottom: 1rem;
        position: relative;
        overflow: hidden;
        border-radius: 1rem;
        .user-name {
          position: absolute;
          bottom: 0.24rem;
          left: 50%;
          transform: translateX(-50%);
          width: 12rem;
          height: 3.6rem;
          line-height: 3.6rem;
          font-size: 2rem;
        }
        .icon {
          position: absolute;
          top: 0.5rem;
          left: 50%;
          transform: translateX(-50%);
          width: 5.6rem;
          z-index: 2;
        }
      }
      .avatar-box,
      .avatar-border {
        width: 100%;
      }
      .avatar-border {
        position: absolute;
        top: 0;
        left: 0;
      }
      .avatar {
        width: 100%;
        object-fit: cover;
        border-radius: 1.4rem 1.4rem;
        margin-bottom: 1.4rem;
        height: calc(100% - 4rem)
      }
    }
  }
}
</style>
